type SubmissionState = {
  studyDate: string
  taskRevision: number
  photoSubmission: null | { id: string; status: string }
}

// A previous rejected submission, another day, or revised tasks are not this upload.
export const hasNewPhotoSubmission = (before: SubmissionState, after: SubmissionState) =>
  before.studyDate === after.studyDate && before.taskRevision === after.taskRevision &&
  Boolean(after.photoSubmission && after.photoSubmission.id !== before.photoSubmission?.id &&
    ['pending', 'approved', 'retry_requested'].includes(after.photoSubmission.status))

export const confirmPhotoSubmission = async <T extends SubmissionState>(
  before: T, read: () => Promise<T>,
  pause: () => Promise<void> = () => new Promise((resolve) => setTimeout(resolve, 1500)),
): Promise<T | null> => {
  for (let attempt = 0; attempt < 3; attempt += 1) {
    if (attempt) await pause()
    try {
      const current = await read()
      if (hasNewPhotoSubmission(before, current)) return current
    } catch { /* A failed status check is not proof that the upload failed. */ }
  }
  return null
}
